"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _react = _interopRequireDefault(require("react"));
var _HBBannerBase = _interopRequireDefault(require("../HBBanner/HBBannerBase"));
var _Bell = _interopRequireDefault(require("@honeybook/icons/dist/icons/Bell24"));
var _excluded = ["whiteBanner", "actionsTheme"];
var actionThemeToButtonTheme = function actionThemeToButtonTheme(whiteBanner) {
  return {
    primary: whiteBanner ? 'primary' : 'primary-blue',
    secondary: 'secondary-solid-secondary',
    'button-link': 'button-link-blue'
  };
};
var InfoBanner = function InfoBanner(_ref) {
  var whiteBanner = _ref.whiteBanner,
    _ref$actionsTheme = _ref.actionsTheme,
    actionsTheme = _ref$actionsTheme === void 0 ? 'primary' : _ref$actionsTheme,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_HBBannerBase["default"], (0, _extends2["default"])({
    icon: _Bell["default"]
  }, props, {
    actionsTheme: actionsTheme,
    accentLine: _colors["default"].blue20,
    background: _colors["default"].blue20_08,
    whiteBanner: whiteBanner,
    primaryActionTheme: actionThemeToButtonTheme(whiteBanner)[actionsTheme]
    // TODO: remove prop in favour of css
    ,
    actionTextTransform: actionsTheme === 'button-link' ? 'none' : 'uppercase'
  }));
};
var _default = exports["default"] = InfoBanner;
//# sourceMappingURL=InfoBanner.js.map